import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CabinetClientPageComponent } from '@nebalkon-workspace/cabinet-client';
import { staffCabinetNavLink } from '../navigation/staff-cabinet-nav.util';
import { StaffBoxTypeFormComponent } from './staff-box-type-form.component';

@Component({
  selector: 'lib-staff-box-type-form-page',
  imports: [CabinetClientPageComponent, StaffBoxTypeFormComponent],
  template: `
    <lib-cabinet-client-page
      titleKey="admin.boxTypes.create.title"
      [parentLink]="boxTypesLink"
      parentLabelKey="STAFF.CABINET.NAV.BOX_TYPES"
    >
      <lib-staff-box-type-form />
    </lib-cabinet-client-page>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaffBoxTypeFormPageComponent {
  protected readonly boxTypesLink = staffCabinetNavLink('box-types');
}
